import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteFrequencyByIndex } from "../../../api/wordsApi";
import { COUNTER_DATA } from "./queryKeys";

export const useDeleteFrequencyByIndexMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (n: number) => deleteFrequencyByIndex(n),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [COUNTER_DATA] });
    },
  });
};